import type { IconProps } from '../components/IconSvg';
import { IconSvg } from '../components/IconSvg';

export function Pin(props: IconProps) {
  return (
    <IconSvg {...props}>
      <path
        d="M11.7143 4.83333H24.2857V19.1667H11.7143V4.83333ZM12.7143 5.83333V18.1667H23.2857V5.83333H12.7143Z"
        fill={props.baseColor}
      />
      <path d="M11.5714 3.16667C11.5095 3.16667 11.4286 3.224 11.4286 3.33334V4.66667C11.4286 4.77601 11.5095 4.83334 11.5714 4.83334H24.4286C24.4905 4.83334 24.5714 4.77601 24.5714 4.66667V3.33334C24.5714 3.224 24.4905 3.16667 24.4286 3.16667H11.5714ZM10.4286 3.33334C10.4286 2.7063 10.9232 2.16667 11.5714 2.16667H24.4286C25.0767 2.16667 25.5714 2.7063 25.5714 3.33334V4.66667C25.5714 5.29371 25.0767 5.83334 24.4286 5.83334H11.5714C10.9232 5.83334 10.4286 5.29371 10.4286 4.66667V3.33334Z" />
      <path d="M10.2857 19.1667C10.2238 19.1667 10.1429 19.224 10.1429 19.3333V22C10.1429 22.1093 10.2238 22.1667 10.2857 22.1667H25.7143C25.7762 22.1667 25.8571 22.1093 25.8571 22V19.3333C25.8571 19.224 25.7762 19.1667 25.7143 19.1667H10.2857ZM9.14285 19.3333C9.14285 18.7063 9.63754 18.1667 10.2857 18.1667H25.7143C26.3624 18.1667 26.8571 18.7063 26.8571 19.3333V22C26.8571 22.627 26.3624 23.1667 25.7143 23.1667H10.2857C9.63754 23.1667 9.14285 22.627 9.14285 22V19.3333Z" />
      <path
        d="M16.8571 22.1667H19.1429V32.4315L18 33.7648L16.8571 32.4315V22.1667ZM17.8571 23.1667V32.0616L18 32.2282L18.1429 32.0616V23.1667H17.8571Z"
        stroke={props.baseColor}
      />
    </IconSvg>
  );
}
